import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'

interface Signature {
  Element: HTMLDivElement
  Args: {
    isFavourite?: boolean
    name: string
    bookCount: number
  }
}

export const CollectionCardFooter: TOC<Signature> = <template>
  <div ...attributes>
    <span class="text-dusty-black-400 text-base {{if @isFavourite 'font-bold'}}">{{@name}}</span>
    <span class="text-dusty-black-250 text-base">{{t "bookLibrary.bookCount" count=@bookCount}}</span>
  </div>
</template>
